import BaseService from '../../base/base_service';

export default class GamesCorrelationService extends BaseService {
    static CLASS = 'GamesCorrelationService';

    init(params) {
        super.init(params);
        this._getCorrelatedGamesUrl = params.getCorrelatedGamesUrl;
    }

    getCorrelatedGames(gameType, numberOfGames = 3) {
        return  this._readCorrelatedGames(gameType)
                    .then(correlatedGames => {

                        if(correlatedGames.length === 0) {
                            return [];
                        }

                        return this._filterRecentlyPlayed(correlatedGames)
                                   .then(filteredGames => this._filterByGamesInformation(filteredGames))
                                   .then(filteredGames => this._filterByLayout(filteredGames))
                                   .then(filteredGames => filteredGames.slice(0, numberOfGames));
                    });
    }


    _cachedCorrelatedGames = {};

    _readCorrelatedGames(gameType) {
        let correlatedGames = this._cachedCorrelatedGames[gameType];
        if(correlatedGames) {
            return Promise.resolve(correlatedGames);
        }

        return this.serviceFactory.http2Service()
            .post(this._getCorrelatedGamesUrl, {
                gameType: gameType
            })
            .then(correlatedGames => {
                correlatedGames = correlatedGames || [];
                this._cachedCorrelatedGames[gameType] = correlatedGames;
                return correlatedGames;
            });

    }

    _filterRecentlyPlayed(correlatedGameTypes) {
        return this.serviceFactory.recentlyPlayedService().getRecentlyPlayedList().then(gameTypes => {
            let recentlyPlayedMap = {};
            gameTypes.forEach(gt => recentlyPlayedMap[gt] = gt);

            return correlatedGameTypes.filter(gt => !recentlyPlayedMap[gt]);
        })
    }

    _filterByGamesInformation(correlatedGameTypes) {
        return this.serviceFactory.gamesInformationService().getGamesInfo(correlatedGameTypes)
            .then(gamesInfo => {
                let result = [];
                correlatedGameTypes.forEach(gt => {
                    let gameInfo = gamesInfo[gt];
                    if(gameInfo && gameInfo.restriction.isGameAllowedToPlayReal()) {
                        result.push(gt);
                    }
                });

                return result;
            });
    }

    _filterByLayout(correlatedGameTypes) {
        let result = this.serviceFactory.integrationService().filterInLayoutGames(correlatedGameTypes);
        if(result) {
            return result;
        }

        return Promise.resolve(correlatedGameTypes);

    }
}